import { useState } from 'react'
import { Box, Collapse, Group, Text, ThemeIcon, UnstyledButton } from '@mantine/core'
import { IconType } from 'react-icons'
import { TbChevronRight } from 'react-icons/tb'
import { useNavigate, useLocation } from '@tanstack/react-router'
import classes from './NavBarLinksGroup.module.css'
import { clsx } from 'clsx'
import { AccessCategory } from '@/api/main/types.gen'

export function LinksGroup({
  icon: Icon,
  label,
  initiallyOpened,
  links,
  mainLink,
}: {
  icon: IconType
  label: string
  initiallyOpened?: boolean
  links?: { label: string; link: string; permission?: AccessCategory | null }[]
  mainLink?: string
  collapsed?: boolean
}) {
  const navigate = useNavigate()
  const location = useLocation()

  const hasLinks = Array.isArray(links)
  const [opened, setOpened] = useState(initiallyOpened || false)

  const isActive =
    mainLink === location.pathname ||
    (hasLinks &&
      links.some(link => {
        if (link.link === location.pathname) return true

        if (location.pathname.startsWith(link.link + '/')) return true

        return false
      }))

  const items = (hasLinks ? links : []).map(link => {
    const isLinkActive = link.link === location.pathname || location.pathname.startsWith(link.link + '/')
    return (
      <Text<'a'>
        component="a"
        href={link.link}
        key={link.label}
        onClick={event => {
          event.preventDefault()
          navigate({ to: link.link })
        }}
        className={clsx({
          [classes.link]: true,
          [classes.active]: isLinkActive,
        })}
      >
        {link.label}
      </Text>
    )
  })

  return (
    <>
      <UnstyledButton
        onClick={() => {
          setOpened(o => !o)
          if (mainLink) {
            navigate({ to: mainLink })
          }
        }}
        className={clsx({
          [classes.control]: true,
          [classes.active]: isActive && !hasLinks,
        })}
      >
        <Group justify="space-between" gap={0}>
          <Box style={{ display: 'flex', alignItems: 'center' }}>
            <ThemeIcon variant="light" size={30} className={`${classes.icon} ${isActive ? classes.active : ''}`}>
              <Icon size={18} />
            </ThemeIcon>
            <Box ml="md">{label}</Box>
          </Box>
          {hasLinks && (
            <TbChevronRight
              strokeWidth={1.5}
              size={16}
              className={classes.chevron}
              style={{
                transform: opened ? 'rotate(-90deg)' : 'none',
              }}
            />
          )}
        </Group>
      </UnstyledButton>
      {hasLinks ? <Collapse in={opened}>{items}</Collapse> : null}
    </>
  )
}
